import * as React from "react";
import { useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';
import { StringHelpers } from '../helpers/StringHelpers';

export interface ContributieProps {
  formFieldDefinition: any;
  forms?: any;
  formName?: string;
  payload?: any;  
}

export const Contributie = (props: ContributieProps) => {
  const [label , setLabel] = useState("");
  const [title, setTitle] = useState("");
  const [richTextHtml , setRichTextHtml] = useState("");
  const [hasRichText , setHasRichText] = useState(false);
  useEffect(() => {
    if (props.formFieldDefinition.lidVoordelenRichtText !== undefined && props.formFieldDefinition.lidVoordelenRichtText !== "") {
      setHasRichText(true);
      setRichTextHtml(ReactHtmlParser(props.formFieldDefinition.lidVoordelenRichtText));
    }

    let titleHelper = props.formFieldDefinition.title;
    let labelHelper = props.formFieldDefinition.label;

    let data = {};

    if (props.formFieldDefinition.form) {
      data = {...props.forms[props.formFieldDefinition.form],
        ...props.forms[props.formName]};
    } else {
      data = {...props.forms[props.formName]};
    }

    if (!!props.formFieldDefinition.includePayload) {
      data = {...data, ...props.payload};
    }

    setTitle(StringHelpers.replacePropertiesInString(titleHelper, data, true));
    setLabel(StringHelpers.replacePropertiesInString(labelHelper, data, true));
  } , [
    props.forms,
    props.formName,
    props.formFieldDefinition,
    props.payload
  ]);

  if (!props.formFieldDefinition) {
    return <></>;
  } 

  return <div key={"renderCustomField-" + props.formFieldDefinition.name} className="row">
    <div className={props.formFieldDefinition.toonLidVoordelen !== undefined && props.formFieldDefinition.toonLidVoordelen === true ? "form-contributiepanel col-12 col-lg-4" : "form-contributiepanel col-12"}>
      <div className="form-contributiepanel__title">
        <h2>{title}</h2>
      </div>
      <div className="form-contributiepanel__content">
        <div className="form-contributiepanel__text">{props.formFieldDefinition.beforeText}</div>
        <div className="form-contributiepanel__contributie">
            <span className="form-contributiepanel__contributie-bedrag">{label}</span>
            <span className="form-contributiepanel__contributie-periode">{props.formFieldDefinition.periodText}</span>
        </div>
        <div className="form-contributiepanel__highlighted">{ReactHtmlParser(props.formFieldDefinition.afterText)}</div>
        {props.formFieldDefinition.additionalText && <div className="form-contributiepanel__text">{ReactHtmlParser(props.formFieldDefinition.additionalText)}</div>}
        {props.formFieldDefinition.toonLidWordenButton !== undefined && props.formFieldDefinition.toonLidWordenButton === true ? 
        <button type="submit" className="btn btn-success">{props.formFieldDefinition.lidWordenButtonTitle}</button> : null}
        {props.formFieldDefinition.hintContributieTarief && <div className="form-contributiepanel__contributie-tip">{ReactHtmlParser(props.formFieldDefinition.hintContributieTarief)}</div>}
      </div>
    </div>
    {props.formFieldDefinition.toonLidVoordelen !== undefined && props.formFieldDefinition.toonLidVoordelen === true ?
      <div className="form-contributiepanel form-contributiepanel--lidvoordelen col-12 col-lg-8">
        {hasRichText === true ? <>
          <div className="form-contributiepanel__content content__tip-list">
            <div className="form-contributiepanel__prevoordeel-text">{ReactHtmlParser(props.formFieldDefinition.lidVoordelenBeforeText)}</div>
            {richTextHtml} 
          </div>
          </> : 
          <>
            <div className="form-contributiepanel__title"><h2>{ReactHtmlParser(props.formFieldDefinition.lidVoordelenTitle)}</h2></div>
            <div className="form-contributiepanel__content content__tip-list">
            <div className="form-contributiepanel__prevoordeel-text">{ReactHtmlParser(props.formFieldDefinition.lidVoordelenBeforeText)}</div>
              <ul className="content__tip-list-list">
                  {props.formFieldDefinition.lidVoordelen && props.formFieldDefinition.lidVoordelen.map((lidVoordeel : string, index : number) =>
                    <li key={props.formFieldDefinition.name + "lidvoordeel" + index}>{lidVoordeel}</li>
                  )}                        
              </ul>        
            </div>
          </>
        }
      </div> : null}
    </div>;
};